/* istanbul ignore file */
import { array as codecArray, number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PutLockedRowsAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    [
        'lockedRows',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.object([
            ['id', codecNumber],
            ['lockId', codecString, 'lock_id'],
        ])),
        'locked_rows',
    ],
]);
export class PutLockedRowsAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutLockedRowsAssignmentDataParser.decode(input).map(res => new PutLockedRowsAssignmentData(res));
    }
    static unsafeDecode(input) {
        return PutLockedRowsAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutLockedRowsAssignmentDataParser.encode(data);
    }
    static schema() {
        return PutLockedRowsAssignmentDataParser.schema();
    }
}
